export type TImageSettings = {
  width: string
  caption: string
  alt: string
  url: string
}

export enum EWidthTypes {
  px = 'px',
  percent = '%',
  em = 'em',
}
